/* eslint-disable @angular-eslint/directive-selector, @angular-eslint/directive-class-suffix */

import { computed, Directive, input } from '@angular/core';
import { SingleRenderInSourceDirectiveBase } from 'common-ui';
import { ProductDetailRenderTarget, ProductDetailRenderTargetComponents } from './ProductDetailRenderTarget';

@Directive({
  selector: '[renderInProductDetailsView]',
  standalone: true,
})
export class RenderInProductDetailsViewDirective extends SingleRenderInSourceDirectiveBase {
  public override renderArgs = input<string | undefined>(undefined, { alias: 'renderInProductDetailsViewId' });
  public override priority = input<number>(0, { alias: 'renderInProductDetailsViewPriority' });
  public readonly target = input<ProductDetailRenderTarget, ProductDetailRenderTarget | string | undefined>(
    ProductDetailRenderTarget.Default,
    {
      alias: 'renderInProductDetailsView',
      transform: (value) => (value as ProductDetailRenderTarget) ?? ProductDetailRenderTarget.Default,
    },
  );
  protected readonly renderIn = computed(
    () => ProductDetailRenderTargetComponents[this.target()] || ProductDetailRenderTargetComponents[ProductDetailRenderTarget.Default],
  );
}
